exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.buscar-solicitacoes .faixa-de-acoes-dos-filtros .botao[data-v-6bfd8baa] {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 40px;\n  padding: 0 16px;\n  margin-top: 0;\n}\n.lista-de-erros-do-filtro[data-v-6bfd8baa] {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.lista-de-erros-do-filtro li + li[data-v-6bfd8baa] {\n  margin-top: 4px;\n}\n@media (min-width: 600px) and (max-width: 899px) {\n.buscar-solicitacoes .linha-de-filtros .grade__coluna[data-v-6bfd8baa] {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false,"url":true,"alias":{"fonts":"..fonts"}}!./~/vue-loader/lib/style-compiler?{"id":"data-v-6bfd8baa","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/controle-de-solicitacoes/ListaDeSolicitacoes.vue
// module id = 997
// module chunks = 1